import { Box, Button, Grid, Typography } from "@mui/material";
import React, { useState, useEffect, useMemo } from "react";
import PaymentStatusCard from "./PaymentStatusCard";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import AlertMessage from "./AlertMessage";
import { useSelector, useDispatch } from "react-redux";
import {
  formatIndianNumber,
} from "../common-functions/PaymentCommonFunctions";
import { useFormik } from "formik";
import TextFieldInput from "../../../../components/TextFieldInput";
import {
  createRazorpayOrder,
  verifyVoucherPayment,
  getVoucherById,
} from "../../voucher-form.slice";
import { useParams } from "react-router-dom";
import { useRazorpayPayment } from "../../components/payments/useRazorpayPayment";
import greenTriangle from "../../../../assets/icons/green-triangle.svg"
import blueTriangle from "../../../../assets/icons/blue-triangle.svg"
import yellowTriangle from "../../../../assets/icons/yellow-triangle.svg"
import SummaryHeader from "./SummaryHeader";
import {  EOIFormStatus, EOIPaymentStatus, FORM_PHASE, GATEWAY,getFrontEndStatus, PAYMENT_ENTITY_TYPE } from "../../../../config/constant";
import * as Yup from "yup";
import { useEasebuzzPayment } from "../payments/useEasebuzzPayment";
import PaymentFailedModal from "../../../new-booking-form/Individual-components/PaymentFailedModal";
import { getCurrentFormPhase } from "../../../../utilis/common-funtions";
import InfoCard from "../../../../components/InfoCard";
import { useTranslation } from "react-i18next";
import { getAgreementValueBreakdown } from "../../../../pages/reusable-preview/components/AgreementValueCalculationCard";

const RelandingPaymentStatus = () => {
  const [paymentAmount, setPaymentAmount] = useState("");
  const { applicantData } = useSelector((state) => state.voucherForm);
  const { voucherId } = useParams();
  const { enquiryDetails } = useSelector((state) => state?.newBookingForm);
  const unitDetails = enquiryDetails?.data
  const isUnitNoPresent = Boolean(applicantData?.opportunityId);
  const { t } = useTranslation();

  const voucherEoiPaidForAgreement = useMemo(() => {
    const pd = applicantData?.paymentDetails;
    let amountPaid = Number(pd?.totalAmountPaid) || 0;
    if (!amountPaid && Array.isArray(pd?.transactions)) {
      amountPaid = pd.transactions.reduce((sum, txn) => sum + (Number(txn?.paidAmount) || 0), 0);
    }
    return amountPaid;
  }, [applicantData?.paymentDetails]);

  const applicantDataForAgreement = useMemo(() => {
    const raw = unitDetails?.TotalAgreementValue;
    if (raw == null || raw === "") return null;
    const agreementValue = Number(raw);
    if (Number.isNaN(agreementValue) || agreementValue <= 0) return null;
    return {
      unitDetails: { totalAgreementValue: agreementValue },
      voucherPayments: voucherEoiPaidForAgreement > 0 ? [{ paidAmount: voucherEoiPaidForAgreement }] : [],
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [unitDetails?.TotalAgreementValue, applicantData?.unitDetails?.totalAgreementValue, voucherEoiPaidForAgreement]);

  const agreementBreakdown = useMemo(
    () => (applicantDataForAgreement ? getAgreementValueBreakdown(applicantDataForAgreement) : null),
    [applicantDataForAgreement]
  );

  const hasAgreementValue = Boolean(agreementBreakdown?.agreementValue > 0);

  const entity = getCurrentFormPhase(applicantData?.formPhase);
  const dispatch = useDispatch();
  const {
    initiatePayment,
    paymentResponse,
  } = useRazorpayPayment();
  const paymentStatusformik = useFormik({
    initialValues: {
      amount: "",
    },
    validationSchema: Yup.object({
      amount: Yup.string().required("Please enter amount in field to Pay")
    })
  });

  useEffect(() => {
    if (hasAgreementValue && agreementBreakdown?.finalPayableAmount != null) {
      const value = String(agreementBreakdown.finalPayableAmount);
      paymentStatusformik.setFieldValue("amount", value);
      setPaymentAmount(value);
    } else {
      paymentStatusformik.setFieldValue("amount", "");
      setPaymentAmount("");
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasAgreementValue, agreementBreakdown?.finalPayableAmount]);

  const { initiateEasebuzzPayment,loading, paymentResponse:easebuzzPaymentResponse } = useEasebuzzPayment()
  const [openPaymentFailedModal,setOpenPaymentFailedModal] = useState(false)
  const [failedAmount,setFailedAmount]= useState('')

  // eslint-disable-next-line no-unused-vars
  const [verifying, setVerifying] = useState(false);

  const preferredUnitRows = [
    { label: t("relandingPaymentStatus.label.unitNo"), value: unitDetails?.UnitNo || "-" },
    { label: t("relandingPaymentStatus.label.tower"), value: unitDetails?.BlockTower || "-" },
    { label: t("relandingPaymentStatus.label.floor"), value: unitDetails?.Floor || "-" },
    { label: t("relandingPaymentStatus.label.configuration"), value: unitDetails?.unitType || "-" },
    {
      label: t("relandingPaymentStatus.label.area"),
      value: unitDetails?.SuperBuiltupAreaSFt
        ? `${unitDetails.SuperBuiltupAreaSFt} Sq.ft`
        : "-"
    }
  ];

  const agreementValueRows = useMemo(() => {
    if (!agreementBreakdown) return [];
    const b = agreementBreakdown;
    return [
      { label: t("relandingPaymentStatus.label.agreementValue"), value: `₹${formatIndianNumber(b.agreementValue)}` },
      { label: t("relandingPaymentStatus.label.agreementPercentage"), value: `₹${formatIndianNumber(b.ninePercentOfAV)}` },
      { label: t("relandingPaymentStatus.label.gstCharges"), value: `₹${formatIndianNumber(b.gstOnNinePercent)}` },
      { label: t("relandingPaymentStatus.label.totalAmount"), value: `₹${formatIndianNumber(b.totalCalculatedAmount)}` },
      { label: t("relandingPaymentStatus.label.paidAmount"), value: `₹${formatIndianNumber(b.voucherEoiPaid)}` },
      { label: t("relandingPaymentStatus.label.payableAmount"), value: `₹${formatIndianNumber(b.finalPayableAmount)}`, dividerTop: true }
    ];
  }, [agreementBreakdown, t]);

  const handleEasebuzzPay = async (amount) => {
        await paymentStatusformik.validateForm();
        paymentStatusformik.setTouched({ amount: true });
        if(!amount) return
      try {
        const orderRes = await dispatch(
          createRazorpayOrder({
            amount,
            entityType: PAYMENT_ENTITY_TYPE.VOUCHER,
            entityId:applicantData?.id?.toString(),
            projectId:applicantData?.campaignId,
            gateway: GATEWAY?.EASEBUZZ,
           
            redirectUrl: window.location.href,
             notes: {
            productInfo:  applicantData?.uniqueReferenceId,
            voucherId: voucherId,
            voucherAmount: Number(PaymentObject?.amountPayable),
            guest: {
              name: `${applicantData?.applicant1?.personalDetails?.firstName} ${applicantData?.applicant1?.personalDetails?.lastName}`.trim(),
              email: applicantData?.applicant1?.personalDetails?.emailAddress,
              phone: applicantData?.applicant1?.personalDetails?.contactNumber,
            },
          },
          })
        ).unwrap();
  
        const orderAccessKey = orderRes.accessKey;
  
        if (!orderAccessKey) {
          throw new Error(
            "Backend did not return access_key. Check createRazorpayOrder response: " +
              JSON.stringify(orderRes)
          );
        }
  
        await initiateEasebuzzPayment({
          orderAccessKey,
          easebuzzKey:orderRes?.easebuzzKey
        });

      } catch (err) {
        setFailedAmount(amount);
        setOpenPaymentFailedModal(true);
        console.error("Failed to initiate payment:", err);
      }

    };


  const handleRazorPay = async (amount) => {
    await paymentStatusformik.validateForm();
    paymentStatusformik.setTouched({ amount: true });

    try {
      // 1. Create order
      const orderRes = await dispatch(
        createRazorpayOrder({
          amount: amount,
          entityType: PAYMENT_ENTITY_TYPE.VOUCHER,
          entityId: applicantData?.id?.toString(),
          projectId:applicantData?.campaignId,
          gateway: GATEWAY?.RAZORPAY,
          notes: {
            voucherId: voucherId,
            voucherAmount: Number(PaymentObject?.amountPayable),
            productInfo: applicantData?.uniqueReferenceId,
            guest: {
              name: `${applicantData?.applicant1?.personalDetails?.firstName} ${applicantData?.applicant1?.personalDetails?.lastName}`.trim(),
              email: applicantData?.applicant1?.personalDetails?.emailAddress,
              phone: applicantData?.applicant1?.personalDetails?.contactNumber,
            },
          },
        })
      ).unwrap();
      // 2. Open Razorpay popup
      initiatePayment({
        amount: orderRes?.razorpayOrder?.amount,
        currency: orderRes?.razorpayOrder?.currency,
        orderId: orderRes?.razorpayOrder?.id,
        name: "Puravankara",
        description: "Payment",

        prefill: {
          name: orderRes?.razorpayOrder?.notes?.guest?.name,
          email: orderRes?.razorpayOrder?.notes?.guest?.email,
          contact: orderRes?.razorpayOrder?.notes?.guest?.phone,
        },
        razorpayKey: orderRes?.razorpayKey,
      });
    } catch (err) {
      console.error("Payment failed:", err);
    }
  };
  function extractPaymentDetails(data) {
    // Fallback to 0 if not provided
    const amountPayable = Number(data?.amountPayable) || 0;

    // Prefer `totalAmountPaid` if exists, else sum from transactions
    let amountPaid = Number(data?.totalAmountPaid) || 0;

    if (!amountPaid && Array.isArray(data?.transactions)) {
      amountPaid = data.transactions.reduce((sum, txn) => {
        const paid = Number(txn?.paidAmount) || 0;
        return sum + paid;
      }, 0);
    }

    // Ensure non-negative due
    let amountDue = amountPayable - amountPaid;
    if (amountDue < 0) amountDue = 0;

    return {
      amountPayable,
      amountPaid,
      amountDue,
    };
  }

  const PaymentObject = extractPaymentDetails(applicantData?.paymentDetails);

  useEffect(() => {
    if (!paymentResponse) return;

    let attempts = 0;
    let isVerified = false;
    setFailedAmount('');

    const verifyPayment = async () => {
      if (attempts === 0) setVerifying(true); // start loading
      attempts++;

      const res = await dispatch(
        verifyVoucherPayment({
          orderId: paymentResponse?.razorpay_order_id,
          paymentId: paymentResponse?.razorpay_payment_id,
          signature: paymentResponse?.razorpay_signature,
          gateway: GATEWAY?.RAZORPAY,
          clientResponse:JSON.stringify(paymentResponse)
        })
      );

      if (res?.payload?.status === "success") {
        isVerified = true;
        dispatch(getVoucherById(`/${voucherId}`));
        setPaymentAmount("");
        paymentStatusformik?.resetForm();
      } else if (attempts < 3 && !isVerified) {
        // retry after short delay
        setTimeout(verifyPayment, 2000);
      } else {
        // stop loading after all attempts fail
        setVerifying(false);
      }
    };

    verifyPayment();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paymentResponse]);

  useEffect(() => {
    if (!easebuzzPaymentResponse) return;

    if (easebuzzPaymentResponse && easebuzzPaymentResponse?.status === "failure") {
      setFailedAmount(easebuzzPaymentResponse?.amount)
      setOpenPaymentFailedModal(true)
      return;
    }
    let attempts = 0;
    let isVerified = false;
    setFailedAmount('');

    const verifyPayment = async () => {
      if (attempts === 0) setVerifying(true); // start loading
      attempts++;

      const res = await dispatch(
        verifyVoucherPayment({
          orderId: easebuzzPaymentResponse?.txnid,
          paymentId: easebuzzPaymentResponse?.easepayid,
          signature: easebuzzPaymentResponse?.hash,
          gateway: GATEWAY?.EASEBUZZ,
          clientResponse:JSON.stringify(easebuzzPaymentResponse)
        })
      );

      if (res?.payload?.status === "success") {
        isVerified = true;
        dispatch(getVoucherById(`/${voucherId}`));
        setPaymentAmount("");
        paymentStatusformik?.resetForm();
      } else if (attempts < 3 && !isVerified) {
        // retry after short delay
        setTimeout(verifyPayment, 2000);
      } else {
        // stop loading after all attempts fail
        setVerifying(false);
      }
    };
    if (easebuzzPaymentResponse && easebuzzPaymentResponse?.status === "success") {
      verifyPayment();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [easebuzzPaymentResponse]);

  const handleProceedGateway = (selectedGateway) => {
    if (selectedGateway === GATEWAY?.RAZORPAY) {
      //setIsPayViaEasebuzz(false)
      handleRazorPay(failedAmount)
      setFailedAmount('')
    }
    if (selectedGateway === GATEWAY?.EASEBUZZ) {
      //setIsPayViaEasebuzz(true)
      handleEasebuzzPay(failedAmount)
      setFailedAmount('')
    }
    setOpenPaymentFailedModal(false)
  }
  return (
    <Box>
      <SummaryHeader applicantData={applicantData} fromRelanding={true} />
     {(applicantData?.paidVoucherId || applicantData?.stdEoiId || applicantData?.preEoiId) &&
      (
        <Box mb={2} mt={2}>
          <AlertMessage
            type="info"
            title={`Customers are required to present their ${entity} ID when invited to the launch event to select and finalize their preferred unit.`}
          />
        </Box>
      )}
      <Typography
        sx={{ fontSize: "14px", fontWeight: 600, px: "12px" }}
        mt={2.5}
        mb={1}
      >
        Payment Status
      </Typography>

      {applicantData?.voucherFormStatus !== EOIFormStatus.CANCEL_ACCEPTED &&
        applicantData?.paymentStatus === EOIPaymentStatus.PARTIALLY_PAID && (!applicantData?.paidVoucherId || !applicantData?.stdEoiId || !applicantData?.preEoiId) && (
          <Box mb={2}>
            <AlertMessage
              type="warning"
              title={`${entity} ID Assignment Pending`}
              message={`${entity} ID will be assigned once the complete amount of ₹${formatIndianNumber(
                PaymentObject?.amountPayable
              )} is received.`}
              highlight={`${formatIndianNumber(
                PaymentObject?.amountPayable
              )} is received`}
            />
          </Box>
        )}
      {(applicantData?.voucherFormStatus === EOIFormStatus.CANCEL_ACCEPTED ||
      applicantData?.voucherFormStatus === EOIFormStatus.REFUND_INITIATED )&& (
        <Box mb={2}>
          <AlertMessage
            type="error"
            title={getFrontEndStatus(applicantData?.voucherFormStatus)}
            message=""
          />
        </Box>
      )}
     {(applicantData?.voucherFormStatus === EOIFormStatus.CANCELLED  )&& (
        <Box mb={2}>
          <AlertMessage
            type="error"
            title={getFrontEndStatus(applicantData?.voucherFormStatus)}
            message=""
          />
        </Box>
      )}

      {!isUnitNoPresent && (
        <Grid container spacing={2} mb={2}>
          <Grid item xs={12} sm={6} md={4}>
            <PaymentStatusCard
              img={blueTriangle}
              amount={formatIndianNumber(PaymentObject?.amountPayable)}
            title={applicantData?.formPhase  === FORM_PHASE.VOUCHER ?"Voucher Amount" :"EOI Amount"}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <PaymentStatusCard
              img={greenTriangle}
              amount={formatIndianNumber(PaymentObject?.amountPaid)}
              title="Amount Paid"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <PaymentStatusCard
              img={yellowTriangle}
              amount={formatIndianNumber(PaymentObject?.amountDue || 0)}
              title="Balance Due"
            />
          </Grid>
        </Grid>
      )}

      {isUnitNoPresent && (
        <Box sx={{ display: "flex", gap: 2, my: 2 }}>
          <Grid container spacing={2} mb={2}>
            <Grid item xs={12} md={6} sx={{ display: "flex" }}>
              <InfoCard
                title={t("relandingPaymentStatus.label.preferredUnitDetails")}
                rows={preferredUnitRows}
              />
            </Grid>

            {hasAgreementValue && (
              <Grid item xs={12} md={6} sx={{ display: "flex" }}>
                <InfoCard
                  title={t("relandingPaymentStatus.label.agreementValueDetails")}
                  rows={agreementValueRows}
                />
              </Grid>
            )}
          </Grid>
        </Box>
      )}

      <Typography sx={{ fontSize: "14px", mt: 4 }}>
        <span style={{ fontWeight: '500'}}>{t("corporatePaymentOption.paymentOptionForm.note")}:</span> {t("corporatePaymentOption.paymentOptionForm.noteMessage")}
      </Typography>
      <Typography
        sx={{ fontSize: "14px", fontWeight: 600, mt: 1, mb: 1 }}
      >
        Amount
      </Typography>
      <Box
        sx={{
          display: "flex",
          alignItems: "flex-start",
          gap: "24px",
          flexWrap: "wrap",
        }}
      >
        <Box sx={{ maxWidth: "366px" }}>
          <TextFieldInput
            field={{
              placeholder: "Enter Amount",
              name: "amount",
              required: false,
              handleOnChange: (e) => {
                const rawValue = e.target.value || "";
                const numericValue = rawValue.replace(/\D+/g, "");

                paymentStatusformik.setFieldValue("amount", numericValue);
                setPaymentAmount(numericValue); // ✅ ALWAYS CLEAN
              },

              readonly: false,
            }}
            formik={paymentStatusformik}
          />
        </Box>

        <Button
          variant="contained"
          endIcon={<ChevronRightIcon />}
          onClick={() => handleEasebuzzPay(paymentAmount)}
          sx={{
            backgroundColor: "#1A407D",
            textTransform: "none",
            fontSize: "14px",
            px: 3,
            py: 1.2,
            borderRadius: "8px",
            fontWeight: 400,
            "&:hover": {
              backgroundColor: "#1A407D",
            },
          }}
          disabled={loading}
        >
          Pay Now
        </Button>
      </Box>
      <PaymentFailedModal open={openPaymentFailedModal} onClose={() => { setOpenPaymentFailedModal(false) }} onProceed={(selectedGateway) => { handleProceedGateway(selectedGateway) }} />
    </Box>
  );
};

export default RelandingPaymentStatus;